<template>
  <v-dialog
      v-model="modal"
      persistent
      max-width="400"
  >
    <v-card class="nv-dialog nv-confirm">
      <div class="nv-confirm__body">
        <span class="nv-confirm__icon">
          <v-icon large color="secondary">mdi-help-circle-outline</v-icon>
        </span>
        <h4 class="nv-dialog__title">İşlemi Onaylıyor musunuz?</h4>
        <p class="nv-confirm__text"><span v-html="content"></span></p>
      </div>
      <div class="nv-dialog__footer">
        <v-btn
            text
            class="nv-btn"
            @click="modal = false"
        >
          Hayır
        </v-btn>
        <v-btn
            color="primary"
            depressed
            class="nv-btn"
            @click="Confirm"
        >
          Evet, Devam Et
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Confirm",
  props: ["value"],
  data() {
    return {
      modal: false,
      content: null
    }
  },
  methods: {
    ModalOpen(val) {
      this.content = val
      this.modal = true
    },
    Confirm() {
      switch (this.value) {
        case 'DeActive':
          this.$emit('deActive')
          break;
        case 'Active':
          this.$emit('active')
          break;
      }
      this.modal = false
    }
  }
}
</script>

<style scoped>

</style>